import { Dispatch, SetStateAction } from 'react';

import { SecureStorage } from '@/plugin/crypto';
import { PageMapType, SearchParamsType } from '@/types/Common.types';

interface PaginationProps<T> {
	pageMap: PageMapType;
	setParams: Dispatch<SetStateAction<T>>;
}
export default function Pagination<T extends SearchParamsType>({ pageMap, setParams }: PaginationProps<T>) {
	const secureStorage = new SecureStorage(sessionStorage);
	const userInfo = secureStorage.getItem('user-storage', 'user-storage');

	const totalCount = pageMap?.totRow;
	const aliveCount = pageMap?.aliveRow;
	const deadCount = pageMap?.deadRow;
	const noSetCount = pageMap?.noSetRow;
	const powerOffCount = pageMap?.powerOffRow;
	const poorComuCount = pageMap?.poorComuRow;
	const dataPerPage = secureStorage.getItem('user-storage', 'user-storage').member_dataPerPage;
	const buttonPerPage = Math.ceil(pageMap?.totRow / dataPerPage) < 5 ? Math.ceil(pageMap?.totRow / dataPerPage) : 5;
	const pageNo = pageMap?.curPage;
	const totalPage = pageMap?.totPage;
	const hasNext = totalPage !== pageMap?.curPage;
	const options = [10, 15, 20, 25, 30, 40, 50];
	const currentPageSection = Math.ceil((totalPage / buttonPerPage) * (pageNo / totalPage));
	const startPage = Math.max(1, (currentPageSection - 1) * buttonPerPage + 1);
	const endPage = buttonPerPage * currentPageSection > totalPage ? totalPage : buttonPerPage * currentPageSection;
	const buttonCount = endPage - startPage + 1;

	const isAdmin = userInfo.member_flag === 1;
	const isNoMem = userInfo.member_flag === 5;

	const handleDataPerPageChange = (newPerPage: number) => {
		secureStorage.setItem(
			'user-storage',
			{
				...secureStorage.getItem('user-storage', 'user-storage'),
				member_dataPerPage: newPerPage,
			},
			'user-storage',
		);

		setParams((prev) => ({ ...prev, pageDTO: { curPage: 1, pagePerRow: newPerPage } }));
	};

	const handlePageNumberChange = (newPageNo: number) => {
		const curPageNo = (() => {
			if (newPageNo <= 0) {
				return 1;
			} else if (newPageNo >= totalPage) {
				return totalPage;
			} else {
				return newPageNo;
			}
		})();

		if (curPageNo !== pageNo && curPageNo >= 1 && curPageNo <= totalPage) {
			setParams((prev) => ({ ...prev, pageDTO: { curPage: curPageNo, pagePerRow: dataPerPage } }));
		}
	};

	return (
		<div className="pagination-wrapper">
			{aliveCount > 0 || deadCount > 0 || noSetCount > 0 || powerOffCount > 0 ? (
				<div className="form-content">
					<div className="">
						<>
							<span>전체: {totalCount}</span>&nbsp;&nbsp;&nbsp;&nbsp; (
							<span style={{ color: '#00FF00' }}>정상: {aliveCount}</span>
							&nbsp;&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;&nbsp;
							<span style={{ color: '#FF0000' }}>고장: {deadCount}</span>
							&nbsp;&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;&nbsp;
							<span>미설치: {noSetCount}</span>
							&nbsp;&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;&nbsp;
							<span>전력차단: {powerOffCount}</span>
							&nbsp;&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;&nbsp;
							<span>통신불량: {poorComuCount}</span>)
						</>
					</div>
				</div>
			) : (
				<div className="form-content">
					<div className="">
						<>
							<>전체: {totalCount}</>
						</>
					</div>
				</div>
			)}
			<nav className="pagination" style={{ minWidth: '300px' }}>
				<div className={`page-item ${pageNo <= 1 && 'disabled'}`}>
					<button type="button" className="page-link page-link-arrow" onClick={() => handlePageNumberChange(1)}>
						&laquo;
					</button>
				</div>
				<div className={`page-item ${pageNo <= 1 && 'disabled'}`}>
					<button
						type="button"
						className="page-link page-link-arrow"
						onClick={() => handlePageNumberChange(endPage - 5)}
					>
						&lsaquo;
					</button>
				</div>
				{Array.from({ length: buttonCount }, (_, i) => startPage + i).map((value, index) => {
					if (value) {
						return (
							<div className={`page-item ${pageNo === value && 'active'}`} key={`pagination-btn-${index}`}>
								<button type="button" className="page-link" onClick={() => handlePageNumberChange(value)}>
									{value}
								</button>
							</div>
						);
					}
				})}
				<div className={`page-item ${!hasNext && 'disabled'}`}>
					<button
						type="button"
						className="page-link page-link-arrow"
						onClick={() => handlePageNumberChange(startPage + 5)}
					>
						&rsaquo;
					</button>
				</div>
				<div className={`page-item ${!hasNext && 'disabled'}`}>
					<button type="button" className="page-link page-link-arrow" onClick={() => handlePageNumberChange(totalPage)}>
						&raquo;
					</button>
				</div>
			</nav>
			<div className="form-content">
				<label className="form-label me-2 fw-normal">1 페이지 당 노출 결과 수</label>
				<select
					className="form-select w-auto"
					value={dataPerPage}
					style={{ minWidth: 'auto' }}
					onChange={(event) => handleDataPerPageChange(+event.target.value)}
				>
					{options.map((value) => (
						<option key={value} value={value}>
							{value}
						</option>
					))}
				</select>
			</div>
		</div>
	);
}
